import { IconEditLine, Text } from "@instructure/ui";
import { t } from "i18next";
import { TruncateToolTip } from "../../../../../utils/TruncateTooltip";

const RenderDescription = ({ row, column, editable }) => {
  return (
    <div
      style={{
        lineHeight: 1,
        padding: "10px 2px",
        display: "block",
        position: "relative",
        textWrap: "wrap",
        textAlign: row.id === "raterRow" ? "center" : "left",
        height: 100,
        cursor: editable && row.id !== "raterRow" ? "pointer" : "default",
        fontWeight: row.id === "raterRow" && "bold",
      }}
    >
      <TruncateToolTip
        renderTip={
          <div style={{ maxWidth: 400 }}>
            {row.ratingLevels[column.key] ||
              t("ratingScale.descriptionPlaceholder")}
          </div>
        }
        maxLines={6}
      >
        <Text
          fontStyle={row.ratingLevels[column.key] === "" ? "italic" : "normal"}
          size="small"
        >
          {row.ratingLevels[column.key] ||
            t("ratingScale.descriptionPlaceholder")}
        </Text>
      </TruncateToolTip>
      {editable && row.id !== "raterRow" && (
        <p style={{ position: "absolute", bottom: 10, right: 5 }}>
          <IconEditLine color="brand" />
        </p>
      )}
    </div>
  );
};

export default RenderDescription;
